import { z } from "zod";
import { idempotencyKey, strictObject } from "./requests.js";
export const setVendorCreditPermissionsBody = strictObject({
  changes: z.array(strictObject({ userId: z.string().uuid(), enabled: z.boolean() })).min(1).max(200),
  idempotencyKey,
}).superRefine((value, ctx) => {
  if (new Set(value.changes.map((row) => row.userId)).size !== value.changes.length) {
    ctx.addIssue({ code: "custom", message: "Each person can only appear once." });
  }
});
export interface VendorCreditPermissionUser {
  userId: string; displayName: string; email: string; active: boolean; enabled: boolean;
}
export interface VendorCreditPermissionsResponse { users: VendorCreditPermissionUser[] }
